var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"headerComDiv"},[_c('header-com')],1),_c('div',{staticStyle:{"margin-top":"60px"}},[_c('router-view')],1),_c('bottom-com')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }